import Model from 'flarum/common/Model';

export default class Event extends Model {
  title          = Model.attribute('title');
  event_start    = Model.attribute('event_start', Model.transformDate);
  event_end      = Model.attribute('event_end',   Model.transformDate);
  duration_minutes = Model.attribute('duration_minutes');
  location       = Model.attribute('location');
  event_type     = Model.attribute('event_type');
  is_deleted     = Model.attribute('is_deleted');
  is_scheduled   = Model.attribute('is_scheduled');
  interested_count = Model.attribute('interested_count');
  discussion_url = Model.attribute('discussion_url');
  createdAt      = Model.attribute('createdAt', Model.transformDate);
  updatedAt      = Model.attribute('updatedAt', Model.transformDate);

  discussion     = Model.hasOne('discussion');
  user           = Model.hasOne('user');
}
